import { Component, OnInit } from "@angular/core";
import { AdminToolsService } from "../../services/admin-tools/admin-tools.service";

type ActivationReminderEmailsResult = {
  total: number;
  succesful: number;
  failure: number;
};

@Component({
  selector: "app-admin-tools",
  templateUrl: "./admin-tools.component.html",
  styleUrls: ["./admin-tools.component.scss"],
})
export class AdminToolsComponent implements OnInit {
  public loading: boolean = false;
  public activationReminderStats: ActivationReminderEmailsResult | undefined;

  constructor(private readonly AdminToolsService: AdminToolsService) {}

  public ngOnInit() {}

  public sendActivationReminderMailsClick() {
    if (this.loading) return;

    const doIt = confirm("Bist Du dir sicher?");
    if (doIt === false) return;

    this.loading = true;
    this.activationReminderStats = undefined;

    this.AdminToolsService.sendActivationReminderEmails()
      .then((res) => {
        this.activationReminderStats = (res as any).stats;
        this.loading = false;
      })
      .catch((error) => {
        console.error(error);
        this.loading = false;
      });
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/admin-tools/admin-tools.component.ts